export const APP_IMPRESSIONS_ACTIVE = "app-impressions-active";
export const APP_IMPRESSIONS_INACTIVE = "app-impressions-inactive";
